import React from "react"
import { observer, useLocalObservable } from "mobx-react"
import { Button, Card, Flex, theme, Typography } from "antd"
import { InboxOutlined } from "@ant-design/icons"

import downloadIcon from "@src/app/assets/icons/downloadCircle.svg"
import { ImageUploaderUI } from "@src/shared/componemts/ImageUploadUI"
import { ImageUpload } from "@src/shared/componemts/ImageUploadUI/entity/ImageUpload"
import css from "./index.module.css"

type Props = {
  isLoading?: boolean
  sendFunds: (value: Blob) => void
}

export const MassPayoutCardsFormUpload = observer(
  ({ isLoading, sendFunds }: Props) => {
    const uploaded = useLocalObservable(() => new ImageUpload())
    const { token } = theme.useToken()

    const onSendFunds = () => {
      return sendFunds(uploaded.blob as Blob)
    }

    return (
      <Flex gap={24} style={{ width: "100%" }} vertical>
        <Flex gap={24} justify={"space-between"}>
          <ImageUploaderUI
            accept=".csv"
            control={uploaded}
            disabled={isLoading}
            placeholder={
              <>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ color: token.colorPrimary }} />
                </p>
                <p className="ant-upload-text">Click to upload CSV file</p>
              </>
            }
          />

          <Card
            bordered={false}
            className={css.downloadWrapper}
            classNames={{
              body: css.downloadWrapperBody,
            }}
            hoverable
            size="small"
            style={{ maxHeight: 180, minWidth: 200 }}
          >
            <Typography.Link
              href={require("@src/app/example/card_mass_payout_example.csv")}
              style={{ display: "block", height: "100%" }}
            >
              <Flex
                align="center"
                gap={16}
                justify="center"
                style={{ height: "100%", width: "100%" }}
                vertical
              >
                <img alt="icon" src={downloadIcon} />
                Download example.CSV
              </Flex>
            </Typography.Link>
          </Card>
        </Flex>

        <Flex justify="flex-end" style={{ width: "100%" }}>
          <Button
            disabled={!uploaded.hasFile}
            id="GENERATED_ID_MASSPAYOUTSFORM_BUTTON_PRECHECK_1"
            loading={isLoading || uploaded.isLoading}
            onClick={onSendFunds}
            size="large"
            type="primary"
          >
            Pre-Check
          </Button>
        </Flex>
      </Flex>
    )
  },
)
